import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { signOut } from '@darice/auth-client';
import { DEFAULT_RETURN_TO, resolveReturnTo } from '../lib/returnTo';

// Logout per design §3.14: signOut clears the darice-session cookie on
// .daricestrategies.com plus in-page state and revokes the Cognito refresh
// token. A revocation failure is surfaced; the local sign-out has already
// happened by then.
export default function Logout() {
  const location = useLocation();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    signOut()
      .then(() => {
        const returnTo = resolveReturnTo(new URLSearchParams(location.search).get('return_to')) ?? DEFAULT_RETURN_TO;
        navigate(`/login?return_to=${encodeURIComponent(returnTo)}`, { replace: true });
      })
      .catch((e) => setError((e as Error).message));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (error) {
    return (
      <main>
        <p className="auth-error" data-testid="logout-error" role="alert">{error}</p>
      </main>
    );
  }
  return (
    <main>
      <p>Signing out...</p>
    </main>
  );
}
